var _FallbackPatientInfoL, _Divider, _Skeleton, _Skeleton2, _Skeleton3, _Divider2, _Divider3;
import React from 'react';
import { useIntl } from '@lumahealthhq/ui-components';
import { Button, Divider, Skeleton, Stack, Typography } from '@lumahealthhq/ui-core';
import { IconEvent } from '../../../TODO/ui-core';
import FallbackPatientInfoLoader from './FallbackPatientInfoLoader';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FallbackScheduleStepLoader() {
  var intl = useIntl();
  return /*#__PURE__*/_jsxs(Stack, {
    gap: 5,
    children: [_FallbackPatientInfoL || (_FallbackPatientInfoL = /*#__PURE__*/_jsx(FallbackPatientInfoLoader, {})), _Divider || (_Divider = /*#__PURE__*/_jsx(Divider, {})), /*#__PURE__*/_jsxs(Stack, {
      spacing: 3,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "subtitle1",
        startIcon: /*#__PURE__*/_jsx(IconEvent, {
          sx: {
            mr: 1.5,
            color: 'text.secondary'
          }
        }),
        children: intl.formatMessage({
          id: "VPbI1v",
          defaultMessage: [{
            "type": 0,
            "value": "Current Appointment Details"
          }]
        })
      }), /*#__PURE__*/_jsxs(Stack, {
        spacing: 1,
        children: [/*#__PURE__*/_jsxs(Stack, {
          spacing: 11,
          direction: "row",
          alignItems: "baseline",
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "subtitle2",
            color: "text.secondary",
            children: intl.formatMessage({
              id: "xaj9Ba",
              defaultMessage: [{
                "type": 0,
                "value": "Provider"
              }]
            })
          }), _Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
            variant: "text",
            height: 24,
            width: 145
          }))]
        }), /*#__PURE__*/_jsxs(Stack, {
          spacing: 3,
          direction: "row",
          alignItems: "baseline",
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "subtitle2",
            color: "text.secondary",
            children: intl.formatMessage({
              id: "WxpO4b",
              defaultMessage: [{
                "type": 0,
                "value": "Appointment Type"
              }]
            })
          }), _Skeleton2 || (_Skeleton2 = /*#__PURE__*/_jsx(Skeleton, {
            variant: "text",
            height: 24,
            width: 145
          }))]
        }), /*#__PURE__*/_jsxs(Stack, {
          spacing: 12,
          direction: "row",
          alignItems: "baseline",
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "subtitle2",
            color: "text.secondary",
            children: intl.formatMessage({
              id: "zjIIl+",
              defaultMessage: [{
                "type": 0,
                "value": "Facility"
              }]
            })
          }), _Skeleton3 || (_Skeleton3 = /*#__PURE__*/_jsx(Skeleton, {
            variant: "text",
            height: 24,
            width: 145
          }))]
        })]
      })]
    }), _Divider2 || (_Divider2 = /*#__PURE__*/_jsx(Divider, {})), /*#__PURE__*/_jsx(Typography, {
      variant: "h5",
      children: intl.formatMessage({
        id: "64RmVd",
        defaultMessage: [{
          "type": 0,
          "value": "Scheduler"
        }]
      })
    }), /*#__PURE__*/_jsx(Skeleton, {
      width: "100%",
      height: 48,
      sx: {
        transform: 'none'
      }
    }), /*#__PURE__*/_jsxs(Stack, {
      sx: {
        mt: 1,
        mb: 0,
        flex: 1
      },
      gap: 4,
      children: [_Divider3 || (_Divider3 = /*#__PURE__*/_jsx(Divider, {})), /*#__PURE__*/_jsx(Stack, {
        direction: "row",
        gap: 2,
        justifyContent: "flex-end",
        children: /*#__PURE__*/_jsx(Button, {
          disabled: true,
          variant: "text",
          children: intl.formatMessage({
            id: "47FYwb",
            defaultMessage: [{
              "type": 0,
              "value": "Cancel"
            }]
          })
        })
      })]
    })]
  });
}